/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mesafeli_Menu_Abonelik_IptalInputs */

const tr_mesafeli_menu_abonelik_iptal = /** @type {(inputs: Mesafeli_Menu_Abonelik_IptalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Harcamalar > Abonelik`)
};

const en_mesafeli_menu_abonelik_iptal = /** @type {(inputs: Mesafeli_Menu_Abonelik_IptalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spending > Subscription`)
};

const de_mesafeli_menu_abonelik_iptal = /** @type {(inputs: Mesafeli_Menu_Abonelik_IptalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ausgaben > Abonnement`)
};

const ru_mesafeli_menu_abonelik_iptal = /** @type {(inputs: Mesafeli_Menu_Abonelik_IptalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Расходы > Подписка`)
};

/**
* | output |
* | --- |
* | "Spending > Subscription" |
*
* @param {Mesafeli_Menu_Abonelik_IptalInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const mesafeli_menu_abonelik_iptal = /** @type {((inputs?: Mesafeli_Menu_Abonelik_IptalInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mesafeli_Menu_Abonelik_IptalInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_mesafeli_menu_abonelik_iptal(inputs)
	if (locale === "de") return de_mesafeli_menu_abonelik_iptal(inputs)
	if (locale === "ru") return ru_mesafeli_menu_abonelik_iptal(inputs)
	return tr_mesafeli_menu_abonelik_iptal(inputs)
});